// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-text {
  text-align: center !important;
}

.highlighted-trial {
  background-color: rgba(56, 142, 60, 0.25); /* Forest green with transparency */
  color: #1B5E20; /* Dark green text for better contrast */
  font-weight: 500;
  text-align: center !important;
}

/* highlighted-trial moused over  */
.highlighted-trial:hover {
  background-color: rgba(56, 142, 60, 0.40) !important; /* More opacity on hover */
  color: #1B5E20;
  text-align: center !important;
}

/* Header text for the grid */
.trial-grid .MuiDataGrid-columnHeaderTitle{
  white-space: normal;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  display: block !important;
  font-size: 0.9em !important;
  max-height: 2.4rem !important;
}

.trial-grid .MuiDataGrid-row {
  font-size: 0.9em !important;
  max-height: 2.3rem !important;
  min-height: 2.3rem !important;
  height: 2.3rem !important;
}

.trial-grid .MuiDataGrid-cell {
  max-height: 2.3rem !important;
  min-height: 2.3rem !important;
  height: 2.3rem !important;
  line-height: 2.3rem !important;
  padding: 5px 5px 7px 5px !important; /* Remove extra padding */
}

.trial-grid{
  padding:0px !important;
  margin:0px !important;
}


`, "",{"version":3,"sources":["webpack://./src/components/trial/trialGrid.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC,EAAE,mCAAmC;EAC9E,cAAc,EAAE,wCAAwC;EACxD,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,oDAAoD,EAAE,0BAA0B;EAChF,cAAc;EACd,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;EAC9B,mCAAmC,EAAE,yBAAyB;AAChE;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB","sourcesContent":[".center-text {\n  text-align: center !important;\n}\n\n.highlighted-trial {\n  background-color: rgba(56, 142, 60, 0.25); /* Forest green with transparency */\n  color: #1B5E20; /* Dark green text for better contrast */\n  font-weight: 500;\n  text-align: center !important;\n}\n\n/* highlighted-trial moused over  */\n.highlighted-trial:hover {\n  background-color: rgba(56, 142, 60, 0.40) !important; /* More opacity on hover */\n  color: #1B5E20;\n  text-align: center !important;\n}\n\n/* Header text for the grid */\n.trial-grid .MuiDataGrid-columnHeaderTitle{\n  white-space: normal;\n  word-wrap: break-word !important;\n  overflow-wrap: break-word !important;\n  display: block !important;\n  font-size: 0.9em !important;\n  max-height: 2.4rem !important;\n}\n\n.trial-grid .MuiDataGrid-row {\n  font-size: 0.9em !important;\n  max-height: 2.3rem !important;\n  min-height: 2.3rem !important;\n  height: 2.3rem !important;\n}\n\n.trial-grid .MuiDataGrid-cell {\n  max-height: 2.3rem !important;\n  min-height: 2.3rem !important;\n  height: 2.3rem !important;\n  line-height: 2.3rem !important;\n  padding: 5px 5px 7px 5px !important; /* Remove extra padding */\n}\n\n.trial-grid{\n  padding:0px !important;\n  margin:0px !important;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
